import React from "react";
import PropTypes from 'prop-types';
import '../../styles/colaboradores.css';

export const CardItem = ({ name, url, text, imageAlt = "Item" }) => {
    return (
        <div className="col-md-4">
            <div className="card mb-3 card-colaborator">
                <div className="row g-0 h-100">
                    <div className="col-md-4 d-flex justify-content-center align-items-center p-2">
                        <img 
                            src={url ? url : require(`../../assets/not_found.jpg`)} 
                            className="img-fluid rounded-start img-colaborator" 
                            alt={imageAlt}
                        />
                    </div>
                    <div className="col-md-8">
                        <div className="card-body">
                            <p className="card-title fs-4 fw-bolder">{name}</p>
                            {text && <p className="card-text">{text}</p>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

CardItem.propTypes = {
    name: PropTypes.string,
    url: PropTypes.string,
    text: PropTypes.string,
    imageAlt: PropTypes.string,
};

